import { charPerToken, cn } from "@moe/priv/utils";

interface Props {
  content: string;
  className?: string;
  [key: string]: any;
}

/**
 * Renders a token count for the provided content string.
 * A token is defined as being 4 characters.
 */
export function TokenCounter({ content, className, ...rest }: Props) {
  return (
    <span className={cn("text-tx-tertiary text-sm font-semibold", className)} {...rest}>
      Token Count: {Math.ceil(content.length / charPerToken)}
    </span>
  );
}
